// Zoom y desplazamiento del vivo (pellizco, rueda del mouse, arrastre). Funciones puras para poder probarlas:
// el contenido se dibuja con `transform: translate(x, y) scale(s)` y origen arriba a la izquierda, dentro de un
// marco de w × h. Nunca se deja ver el borde: a s = 1 no se mueve, a s = 2 se puede recorrer media pantalla.

export const ZOOM_MIN = 1;
export const ZOOM_MAX = 6;
export const SIN_ZOOM = Object.freeze({ s: 1, x: 0, y: 0 });

const entre = (v, min, max) => Math.min(max, Math.max(min, v));

export const limitar = (t, w, h) => {
  const s = entre(t.s, ZOOM_MIN, ZOOM_MAX);
  return { s, x: entre(t.x, w - w * s, 0), y: entre(t.y, h - h * s, 0) };
};

// Zoom manteniendo quieto el punto (px, py) del marco: el que está bajo el mouse o entre los dos dedos.
export const zoomEn = (t, px, py, sNueva, w, h) => {
  const s = entre(sNueva, ZOOM_MIN, ZOOM_MAX);
  const k = s / t.s;
  return limitar({ s, x: px - (px - t.x) * k, y: py - (py - t.y) * k }, w, h);
};

export const mover = (t, dx, dy, w, h) => limitar({ s: t.s, x: t.x + dx, y: t.y + dy }, w, h);

// Rueda: cada "clic" de rueda (deltaY ≈ 100) acerca ~16 %; los touchpads mandan deltas chicos y quedan suaves.
export const factorRueda = (deltaY) => Math.exp(-entre(deltaY, -300, 300) * 0.0015);
